// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckSuggestions-moduleApplicantCreditCheckSuggestions__GBKMQ";
export { _1 as "ApplicantCreditCheckSuggestions" }
